import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationStatusEnums } from '@shared/enums/common.enum';
import {
  TABS_TO_SHOW_WHEN_PENDING_CREATOR,
  TABS_TO_SHOW_WHEN_APPROVED_CREATOR
} from '@shared/constants/tab-approval.constant';
import { AuthService } from '@core/auth.service';

@Pipe({
  name: 'showTabByApproval'
})
export class ShowTabByApprovalPipe implements PipeTransform {

  constructor(
    private readonly authService: AuthService
  ) {}

    transform(
    userProfile: any,
    tab: string
  ): boolean {
    if (!userProfile) {
      return false;
    }

    const status = userProfile?.admin_approval_status;
    const isCreatorApproved =
      status === ApplicationStatusEnums.APPROVED || !!userProfile?.is_creator;
    const isWhiteLabelWebsite = this.authService.isWhiteLabelWebsite();
    const isPending = status === ApplicationStatusEnums.PENDING;
    const isResubmitted = status === ApplicationStatusEnums.RESUBMIT;

    if(!!this.authService.userContext?.fm_user) return true;
    else if(isPending || isResubmitted) {
      return !TABS_TO_SHOW_WHEN_PENDING_CREATOR.includes(tab);
    } else if(isCreatorApproved && !isWhiteLabelWebsite) {
      return !TABS_TO_SHOW_WHEN_APPROVED_CREATOR.includes(tab);
    } else {
      return true;
    }
  }
}
